const PERMISSION_KEY= "personalize:nebula_holdings";
const PAGE_URL = {
    NEBULA_HOLDINGS_PAGE: "/admin/personalize/nebula-holdings"
}

export {PERMISSION_KEY, PAGE_URL}

